import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { useAffiliate } from '../../hooks/useAffiliate'
import { useConnectWallet } from '../../hooks/useConnectWallet'
import ModalInfo from '../../components/ModalInfo'
import ModalStatus from '../../components/ModalStatus'
import DashBoard from './Dashboard'
import SignInForm from './SignInForm'
import ConfirmForm from './ConfirmForm'
import { isCorrectNetwork } from '../../utils'

import './style.scss'
// interface AffiliateState {
//   balanceOfStaking: string
//   link: string
//   isLoginAff: boolean
//   isStaking: boolean
//   info: AffiliateType | null
// }

const Affiliate = () => {
  const {
    signInWithMatamark,
    setLoginAff,
    account,
    connectWallet,
    chainId,
    library,
  } = useConnectWallet()

  const {
    // getBalanceOfStaking,
    // checkStaking,
    //isStaking,
    staking,
    checkTokenApprovel,
    modalStatus,
    setModalStatus,
    // balanceOfStaking,
    mininumRate,
    getAffLink,
    unStake,
    getReward,
    // isApprovedToken,
    approveToken,
  } = useAffiliate()

  let { ref } = useParams<any>()

  const affState = useSelector((state) => state.affiliate)

  const {
    isLoginAff,
    info,
    isStaking,
    commission,
    balanceOfStaking,
    isApprovedToken,
  } = affState

  const [isShowInfo, setShowInfo] = useState(false)

  const onClickBeComeAffiliate = () => {
    approveToken()
  }

  const onClickConfirm = () => {
    const refCode = ref || ''
    staking(refCode)
  }

  const onClickSignIn = () => {
    signInWithMatamark()
  }

  const link = getAffLink()

  const BtnComponent = () => {
    if (account && library) {
      if (!isCorrectNetwork(chainId)) return null

      return (
        <button
          className='btn header--button active'
          onClick={onClickBeComeAffiliate}
        >
          Become affiliate
        </button>
      )
    } else {
      return (
        <button className='btn header--button active' onClick={connectWallet}>
          Unlock Wallet
        </button>
      )
    }
  }

  if (!isStaking && isApprovedToken === 'none') {
    if (account && library) {
      if (!isCorrectNetwork(chainId)) return null
      checkTokenApprovel()
    }
  }

  const compBecomeAffiliate = (
    <div className='container'>
      <div className='header'>
        <h1 className='title head-title'>
          Welcome to One Pirate Referral Program,
        </h1>
        <h1 className='title'>join us today and earn commission</h1>
        <h1 className='title'>up to 10%</h1>
        <p className='sub-title'>
          Earn money by driving traffic and prompting sales across one of the
          world's best crypto
        </p>
        <p className='sub-title-info'>
          Stake 10,000 OneP to begin the One Pirate Referral Program, you can
          unstake this 10,000 OneP when you want to leave the referral program.
        </p>
        <BtnComponent />
      </div>
    </div>
  )

  return (
    <div className='affiliate-page'>
      {!(account && library) ? (
        compBecomeAffiliate
      ) : (
        <>
          {isStaking && isLoginAff && (
            <DashBoard
              balanceOfStaking={balanceOfStaking}
              account={account}
              link={link}
              onUnStake={unStake}
              affInfo={info}
              commission={commission}
              onGetReward={getReward}
            />
          )}
          {isStaking && !isLoginAff && <SignInForm onSingnIn={onClickSignIn} />}
          {!isStaking && isApprovedToken === 'approved' && (
            <ConfirmForm
              mininumRate={mininumRate}
              onClickConfirm={onClickConfirm}
              setShowModalInfo={(data) => setShowInfo(data)}
            />
          )}
          {!isStaking &&
            isApprovedToken === 'unapproved' &&
            compBecomeAffiliate}
          <ModalStatus
            // modalStatus={modalStatus}
            // onCloseModal={() => setModalStatus(false, '', 'none')}
            onConfirm={onClickConfirm}
          />
          <ModalInfo
            className='modal-info info-stake'
            title='Why you need to staking'
            account={account}
            isShowModal={isShowInfo}
            onCloseModal={() => setShowInfo(false)}
            compContent={
              <div className='d-flex flex-column'>
                <div className='d-flex mt-3'>
                  <span>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className='icon-fa-circle'
                    />
                  </span>
                  <span className='text-info-stake text-subtitle'>
                    To be the partner for One Pirate Referral Program, you just
                    only stake 10,000 OneP first to start your referral group
                  </span>
                </div>
                <div className='d-flex mt-3'>
                  <span>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className='icon-fa-circle'
                    />
                  </span>
                  <span className='text-info-stake text-subtitle'>
                    Once stake completed, One Pirate will provide you the
                    reference link.
                  </span>
                </div>
                <div className='d-flex mt-3'>
                  <span>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className='icon-fa-circle'
                    />
                  </span>
                  <span className='text-info-stake text-subtitle'>
                    You will automatically earn 10% commission fee for every
                    OneP swap from any transaction via your provided referral
                    link.
                  </span>
                </div>
                <div className='d-flex mt-3'>
                  <span>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className='icon-fa-circle'
                    />
                  </span>
                  <span className='text-info-stake text-subtitle'>
                    The commission fee is calculated from the swap amount of
                    OneP, in example, Nami swap 100,000 OneP via Mr.Hook’s
                    referral link, Mr.Hook would receive 10,000 OneP as the
                    commission for this transaction.
                  </span>
                </div>
                <div className='d-flex mt-3'>
                  <span>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className='icon-fa-circle'
                    />
                  </span>
                  <span className='text-info-stake text-subtitle'>
                    The commission fee would be automatically transfer to your
                    OneP wallet, you can access to claim your commission reward
                    anytime.
                  </span>
                </div>
              </div>
            }
          />
        </>
      )}
    </div>
  )

  // return (
  //   <div className='affiliate-page'>
  //     {isStaking === null ? null : isStaking ? (
  //       !isLoginAff ? (
  //         <SignInForm onSingnIn={onClickSignIn} />
  //       ) : (
  //         <DashBoard
  //           balanceOfStaking={balanceOfStaking}
  //           account={account}
  //           link={link}
  //           onUnStake={unStake}
  //           affInfo={info}
  //           commission={commission}
  //           onGetReward={getReward}
  //         />
  //       )
  //     ) : (
  //       <div className='container'>
  //         <div className='header'>
  //           <h1 className='title head-title'>Welcome to our Introducers Program</h1>
  //           <h2 className='title'>Earn up to 10% in commission</h2>
  //           <p className='sub-title'>
  //           Earn money by driving traffic and prompting sales across one of the world's best crypto
  //           </p>
  //           <BtnComponent/>
  //         </div>
  //       </div>
  //     )}
  //     <ModalStatus
  //       modalStatus={modalStatus}
  //       onCloseModal={() => setModalStatus(false, '', 'none')}
  //       onConfirm={onClickConfirm}
  //       compContent={
  //         <div className='d-flex flex-column justify-content-center mb-5 confirm-token'>
  //           <h1 className='title mb-5'>You need to staking</h1>
  //           <div className='d-flex justify-content-end'>
  //             Balance: {tokenState.balanceOfToken}
  //           </div>
  //           <div className='detail-container'>
  //             <h3 className='detail-text'>{mininumRate}</h3>
  //             <span>
  //               <img alt='' src={IToken} />
  //               <div className='text-icon'>{NAME_TOKEN}</div>
  //             </span>
  //           </div>
  //         </div>
  //       }
  //     />
  //   </div>
  // )
}

export default Affiliate
